<template>
<div class="navigate-web">
  <Error @reload="getData()" v-if="networkError" />
  <div class="navigate-wrapper" v-else>
    <div class="navigate" :style="inNavigation ? 'height: 0' : ''">
      <div class="navigate-top">
        <div class="naviagte-top__left" @click="goRouteList">
          <img :src="canGoHome ? require('../assets/goback.svg') : require('../assets/gohome.svg')" />
        </div>
        <div class="navigate-form">
          <div class="current-location" @click="handleSelectStart">
            <img src="../assets/my-location.svg" />
            <div class="location" :class="{'disable': !start.name && !start.lon}">{{ start.lon ? start.name || $t('common.myLocation') : $t('navigate.enterStart') }}</div>
          </div>
          <div class="destination" @click="handleSelectEnd">
            <img src="../assets/destination.svg" />
            <div class="location" :class="{'disable': !end.name}">{{ end.name || $t('navigate.enterDestination') }}</div>
          </div>
        </div>
        <div class="exchange" @click="handleExchange">
          <img src="../assets/exchange.svg" />
        </div>
      </div>
      <cube-scroll class="scroll-wrapper"
                   ref="scroll"
                   direction="horizontal"
                   :data="tabs"
                   :options="{bounce: false}"
                   v-if="$i18n.locale === 'en'">
        <div class="navigate-tabs en-tabs">
          <div class="tab-wrapper en-wrapper"
                v-for="(item, index) in tabs"
                :key="item.id">
            <div class="tab en-tab"
                :class="{'active': active === index}"
                @click="handleChangeTab(index)">
              <div class="icon" v-if="active === index" :class="{'sentosa': siteId === '1'}">
                <img :src="item.img" />
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </cube-scroll>
      <div class="navigate-tabs" v-else>
        <div class="tab-wrapper"
            v-for="(item, index) in tabs"
            :key="item.id">
          <div class="tab"
              :class="{'active': active === index}"
              @click="handleChangeTab(index)">
            <div class="icon" :class="{'sentosa': siteId === '1'}">
              <img :src="item.img" />
            </div>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="navigate-route">
      <!-- <div class="card-wrapper">
        <Recommend :list="currentArray" v-show="active === 0 && !showMap" @showmap="handleShowMap" />
        <Bus :list="currentArray" v-show="active === 2 && !showMap" @showmap="handleShowMap" />
        <Cable :list="currentArray" v-show="active === 3 && !showMap" @showmap="handleShowMap" />
      </div> -->
      <div class="empty-wrapper" v-show="showEmpty">
        <div class="bus-empty" v-show="siteId === '129' && active === 2">
          <img src="@/assets/navigate/bus-empty.svg" />
          <div class="empty-text">{{ $t('navigate.busNote') }}</div>
          <div class="empty-bus-btn" @click="handleWechatNav">{{ $t('navigate.useOtherMap') }}</div>
        </div>
        <empty :content="$t('navigate.noContentMsg')" v-show="siteId !== '129' || active !== 2" />
      </div>
      <!-- 从地图右下角进入没有终点信息 -->
      <div class="result-wrapper" v-show="noEnd">
        <div class="result-title">
          <div class="title">{{ $t('navigate.navigateHistory') }}</div>
          <div class="delete-icon" v-if="!noResults" @click="handleDelete">
            <img src="@/assets/delete-sentosa.svg" v-if="siteId === '1'"/>
            <img src="@/assets/delete.svg" v-else />
          </div>  
        </div>
        <div class="no-results" v-if="noResults">{{ $t('navigate.noHistory') }}</div>
        <div class="list-wrapper" v-else>
          <v-result-list :list="results" @result="handleClickResult" />
        </div>
      </div>
      <CMap ref="cmap"
            :endName="end.name"
            :activeIndex="currentIndex"
            :inNavigation="inNavigation"
            :alpha="alpha"
            :inThere="inThere"
            :web="true"
            :iphoneX="iphoneX"
            @change="handleChangeRoute"
            @stop="handleStop"
            @play="handlePlayAudio" />
    </div>
    <!-- 搜索 -->
    <NavigateSearch :inThere="inThere" :header="header" ref="navigateSearch" :geoData="geoData" @selectPlace="handleSelectPlace" />
    <transition name="fade">
      <RouteDetail ref="routeDetail"
                  v-if="!showEmpty && !noEnd"
                  v-show="!inNavigation"
                  :list="currentArray"
                  :startName="start.name"
                  :endName="end.name"
                  :iphoneX="iphoneX"
                  :activeIndex="currentIndex"
                  @mask="handleMask" />
    </transition>
    <div class="start-nav"
        :class="{'shadow': showMask}"
        :style="iphoneX ? 'height: 71px;' : 'height: 37px;'"
        @click="handleNavigate"
        v-show="!inNavigation"
        v-if="currentArray && currentArray.length > 0 && (currentArray[currentIndex].meta.vehicle === 'foot' || currentArray[currentIndex].meta.vehicle === 'car') && !showEmpty">{{ $t('navigate.startMsg') }}</div>
    <transition name="fade">
      <div class="mask" v-if="showMask" @click="closeRouteDetail"></div>
    </transition>
    <audio ref="audio" controls="controls" :src="audioSrc" style="position: fixed; top: -999px; left: 999px" />
  </div>
</div>
</template>

<script>
import NavigateSearch from '@/components/navigate/NavigateSearch'
import CMap from '@/components/navigate/CMap'
import RouteDetail from '@/components/navigate/RouteDetail'
import empty from '@/components/empty'
import { getRouteDetail, getNavHistories, deleteNavHistory, getWebUserId } from '@/fetch/api'
import { pointWithinThere, GetDistance } from '@/utils/index'
import _ from 'lodash'
import Error from '@/components/Error.vue'
import ResultList from '@/components/navigate/ResultList'

export default {
  data () {
    return {
      getPosition: {},
      currentEnv: null,
      start: {
        name: '',
        lon: '',
        lat: '',
        type: '',
        id: ''
      },
      end: {
        name: '',
        lon: '',
        lat: '',
        type: '',
        id: ''
      },
      active: 0,
      tabs: [],
      suggested: [],
      routes: {},
      showEmpty: false,
      currentArray: [
        {
          paths: [
            { time: null, distance: null }
          ],
          meta: { weighting: '' }
        }
      ],
      currentIndex: 0,
      showMap: false,
      showMask: false,
      geoData: {
        lon: '',
        lat: ''
      },
      inThere: false,
      inNavigation: false,
      alpha: 0,
      noPermission: false,
      iphoneX: false,
      Android: false,
      networkError: false,
      audioSrc: '',
      noEnd: false,
      results: [],
      noResults: false,
      canGoHome: false,
      header: null // 从地图右下角进入，没有终点信息
    }
  },
  components: {
    NavigateSearch,
    empty,
    CMap,
    RouteDetail,
    Error,
    'v-result-list': ResultList
  },
  computed: {
    siteId () {
      return this.$store.state.siteId
    }
  },
  created () {
    if (this.$store.state.direct) this.canGoHome=true
    this.isPlaying = false
    if (this.siteId === '1') {
      this.tabs = [
        { id: 1, name: this.$t('navigate.recommendTab'), type: 'suggest', img: '/image/navigate/zhi-xing.svg', component: 'Recommend' },
        { id: 2, name: this.$t('navigate.walk'), type: 'foot', img: '/image/navigate/walk.svg', component: 'Walk' },
        { id: 3, name: this.$t('navigate.bus'), type: 'bus', img: '/image/navigate/bus-white-sentosa.svg', component: 'Bus' },
        { id: 4, name: this.$t('navigate.cable'), type: 'cable', img: '/image/navigate/cable-white-sentosa.svg', component: 'Cable' },
        { id: 5, name: this.$t('navigate.car'), type: 'car', img: '/image/navigate/car-white.svg', component: 'Car' }
      ]
    } else if (this.siteId === '129') {
      this.tabs = [
        { id: 1, name: this.$t('navigate.recommendTab'), type: 'suggest', img: '/image/navigate/zhi-xing.svg', component: 'Recommend' },
        { id: 2, name: this.$t('navigate.walk'), type: 'foot', img: '/image/navigate/walk.svg', component: 'Walk' },
        { id: 3, name: this.$t('navigate.bus'), type: 'bus', img: '/image/navigate/bus-white.svg', component: 'Bus' },
        { id: 5, name: this.$t('navigate.car'), type: 'car', img: '/image/navigate/car-white.svg', component: 'Car' }
      ]
    } else {
      this.tabs = [
        { id: 1, name: this.$t('navigate.recommendTab'), type: 'suggest', img: '/image/navigate/zhi-xing.svg', component: 'Recommend' },
        { id: 2, name: this.$t('navigate.walk'), type: 'foot', img: '/image/navigate/walk.svg', component: 'Walk' },
        { id: 3, name: this.$t('navigate.bus'), type: 'bus', img: '/image/navigate/bus-white.svg', component: 'Bus' },
        { id: 4, name: this.$t('navigate.cable'), type: 'cable', img: '/image/navigate/cable-car.svg', component: 'Cable' },
        { id: 5, name: this.$t('navigate.car'), type: 'car', img: '/image/navigate/car-white.svg', component: 'Car' }
      ]
    }
    this.toast = this.$createToast({
      time: 0,
      txt: this.$t('common.loadingMsg'),
      mask: true
    })
    this.toast.show()
    // document.title = '导航'
    console.log(JSON.parse(decodeURIComponent(this.$route.query.data)))
    // [start_lon, start_lat, start_name, start_type, start_id, end_lon, end_lat, end_name, end_type, end_id]
    let [startLon, startLat, startName, startType, startId, endLon, endLat, endName, endType, endId, clientId, accessToken, userId] = JSON.parse(decodeURIComponent(this.$route.query.data))
    if(!startLat || !startName) startLon = ''
    if(!endLat || !endName)  endLon = ''

    // endLon = ''
    // endLat = ''
    // endName = ''
    // if(!endLon && endId) {
    //   getSubSiteDetail(10).then(res=> {
    //
    //   })
    // }

    if (userId) {
      this.userId = `miniapp_user_${userId}`
    } else if (clientId) {
      this.userId = clientId
    } else {
      this.userId = getWebUserId()
    }


    this.start = {
      name: startName,
      lon: startLon,
      lat: startLat,
      type: startType,
      id: startId
    }
    this.end = {
      name: endName,
      lon: endLon,
      lat: endLat,
      type: endType,
      id: endId
    }
    this.header = accessToken ? { 'X-CLIENT-ID': clientId, 'X-ACCESS-TOKEN': accessToken, 'X-USER-ID': userId } : null
    if (!endLon) {
      this.noEnd = true
      this.getHistoryList()
    } 
    const navigator = window.navigator
    const currentEnv = window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(navigator.userAgent.toLowerCase())
    if (!currentEnv) document.title = this.$t('navigate.pageTitle')
    this.currentEnv = currentEnv
    const Android = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    const iphoneX = /iphone/gi.test(navigator.userAgent) && (screen.height >= 812) && currentEnv
    this.iphoneX = iphoneX
    this.Android = Android
    this.startUpdateLocation(startLon)
    if (startLon) { // 指定起始点时，有值
      this.$nextTick(() => {
        console.log('初始化，有起始点，请求数据')
        this.getData()
      })
    } else {
      console.log('初始化，没有有起始点========')
      this.getPosition = this.$createToast({
        time: 0,
        txt: this.$t('common.loadingMsg'),
        mask: true
      })
      this.getPosition.show()
      navigator.geolocation.getCurrentPosition((res) => {
        const longitude = res.coords.longitude
        const latitude = res.coords.latitude
        this.geoData = {
          lon: longitude,
          lat: latitude
        }
        this.$nextTick(() => {
          this.handleHistories(this.results)
        })
        // console.log(longitude, latitude)
        if (longitude) {
          const inThere = pointWithinThere(longitude, latitude)
          this.inThere = inThere
          if (!inThere && !startLon) {
            // if (latitude > 25) {
            //   this.start = {
            //     name: '楚峰国际中心',
            //     lon: 104.06072,
            //     lat: 30.58074,
            //   }
            //   this.end = {
            //     name: '奥克斯广场',
            //     lon: 104.0550,
            //     lat: 30.5810,
            //   }
            // } else {
            this.$createDialog({
              type: 'alert',
              confirmBtn: {
                text: this.$t('common.confirm')
              },
              content: this.$t('navigate.noteMsg')
            }).show()
            this.start = {
              name: 'VivoCity Station',
              lon: 103.82241,
              lat: 1.2651,
              type: 'SiteStation',
              id: 143
            }
            // this.start = {}
            this.$nextTick(() => {
              this.noEnd = true
              this.getHistoryList()
            })
            // }
          } else {
            this.start = {
              name: '',
              lon: longitude,
              lat: latitude
            }
          }
          if (endLon) { // 有终点信息
            this.$nextTick(() => {
              // this.noEnd = true
              this.getData()
              // this.getHistoryList()
            })
          }
        }
        this.toast.hide()
      }, err => {
        this.toast.hide()
        console.log(err)
        this.$createDialog({
          type: 'alert',
          confirmBtn: {
            text: this.$t('common.confirm')
          },
          content: this.$t('navigate.noteMsg')
        }).show()
        this.start = {
          name: 'VivoCity Station',
          lon: 103.82241,
          lat: 1.2651,
          type: 'SiteStation',
          id: 143
        }
        // this.start = {}
        if (endLon) { // 有终点信息
          this.$nextTick(() => {
            this.getData()
            // this.noEnd = true
          })
        }
      }, { timeout: 5000, enableHighAccuracy: true })
      this.noEnd = true
      this.getHistoryList()
    }
  },
  mounted () {
    const audio = this.$refs.audio

    // On video playing toggle values
    audio.onplaying = () => {
      this.isPlaying = true
    }

    // On video pause toggle values
    audio.onpause = () => {
      this.isPlaying = false
    }

    audio.onended = () => {
      this.isPlaying = false
      this.audioSrc = ''
    }
  },
  beforeDestroy () {
    this.handleStopMonitor()
  },
  methods: {
    goRouteList () {
      if (this.canGoHome) this.$router.go(-1)
      else  this.$router.push({ name: 'map' })
    },
    handleOrientation (res) {
      const alpha = res.webkitCompassHeading
      // console.log('获取到的数据', alpha)
      this.alpha = alpha
      this.$nextTick(() => {
        this.$refs.cmap.updateStatus(null, alpha)
      })
    },
    handleOrientationAbsolute (res) {
      const alpha = 360 - res.alpha
      // console.log('获取到的数据', alpha)
      // alert(`收到数据alpha: ${alpha}`)
      this.alpha = alpha
      this.$nextTick(() => {
        this.$refs.cmap.updateStatus(null, alpha)
      })
    },
    // 获取角度、位置信息
    startUpdateLocation () {
      if (this.Android) {
        window.addEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
      } else {
        window.addEventListener('deviceorientation', this.handleOrientation)
      }
      this.watchId = window.navigator.geolocation.watchPosition((res) => {
        const longitude = res.coords.longitude
        const latitude = res.coords.latitude
        // const longitude = 104.08458
        // const latitude = 30.55183
        // console.log(longitude, latitude)
        if (longitude) {
          this.geoData = {
            lon: longitude,
            lat: latitude
          }
          this.$nextTick(() => {
            this.$refs.cmap.updateStatus(this.geoData, '')
          })
        }
      }, err => {
        console.log(err)
        // this.toast = this.$createToast({
        //   type: 'txt',
        //   txt: this.$t('common.networkErrorMsg')
        // })
        // this.toast.show()
      }, { timeout: 10000, enableHighAccuracy: true })
    },
    getData (index) {
      if (this.start.lat === this.end.lat && this.start.lon === this.end.lon) {
        this.toast = this.$createToast({
          type: 'txt',
          txt: this.$t('navigate.validMsg')
        })
        this.toast.show()
        return
      }
      getRouteDetail({
        start_lat: this.start.lat,
        start_lon: this.start.lon,
        startable_type: this.start.type,
        startable_id: this.start.id,
        endable_type: this.end.type,
        endable_id: this.end.id,
        end_lat: this.end.lat,
        end_lon: this.end.lon,
        source: this.currentEnv ? 'wechat' : 'web',
        user_id: this.userId
      }, this.header).then(res => {
        this.toast.hide()
        // 智能推荐
        let suggested = []
        res.routes = res.routes.filter(item => item.meta)
        // 时间最短排前面
        res.routes.sort((a, b) => {
          return a.meta.weighting.localeCompare(b.meta.weighting)
        })
        res.routes.forEach(route => {
          // 处理路线
          let routes = []
          const startPoint = route.meta.point[0].split(',')
          const endPoint = route.meta.point[1].split(',')
          const firstCoordinates = route.paths[0].points.coordinates.slice(0, 1)[0]
          const lastCoordinates = route.paths[0].points.coordinates.slice(route.paths[0].points.coordinates.length - 1)[0]
          console.log(startPoint, endPoint, firstCoordinates, lastCoordinates)
          route.paths[0].points.coordinates.unshift([parseFloat(startPoint[1]), parseFloat(startPoint[0]), firstCoordinates[2], firstCoordinates[3], firstCoordinates[4]])
          route.paths[0].points.coordinates.push([parseFloat(endPoint[1]), parseFloat(endPoint[0]), lastCoordinates[2], lastCoordinates[3], lastCoordinates[4]])
          if (route.paths[0].points.coordinates.every(point => point[2] === 0)) {
            route.meta.vehicle = 'foot'
          }
          route.paths[0].points.coordinates.forEach((item, index) => {
            const type = item[2]
            if (routes.length === 0 || routes[routes.length - 1].type !== type) {
              if (routes.length > 0) {
                console.log(routes.length)
                const copyItem = item.slice(0, 5)
                copyItem[2] = routes[routes.length - 1].type
                routes[routes.length - 1].array.push(copyItem)
              }
              routes.push({
                type: item[2],
                array: [item]
              })
            } else {
              routes[routes.length - 1].array.push(item)
            }
          })
          route.routeArray = routes
          routes.forEach((item, index) => {
            item.tIndex = this.findBus(route, index)
          })
          if (route.meta.suggested) {
            suggested.push(route)
          }
        })
        const data = _.groupBy(res.routes, 'meta.vehicle')
        this.suggested = suggested
        if (index) {
          const currentArray = data[this.tabs[index].type]
          this.currentArray = currentArray
          if (currentArray.length === 0) {
            this.showEmpty = true
            this.$refs.cmap.hideMap()
          } else {
            this.showEmpty = false
            this.$refs.cmap.showMap(this.tabs[index].type, currentArray, this.geoData)
          }
        } else {
          this.currentArray = suggested
          if (suggested.length === 0) {
            this.showEmpty = true
            this.$refs.cmap.hideMap()
          } else {
            this.showEmpty = false
            this.$refs.cmap.showMap('suggest', suggested, this.geoData)
          }
        }
        this.routes = data
        this.noEnd = false
        this.networkError = false
      }).catch(err => {
        console.log(err)
        this.toast.hide()
        this.networkError = true
      })
    },
    handleChangeTab (index) {
      this.active = index
      this.currentIndex = 0
      if (index === 0) {
        this.currentArray = this.suggested
        if (this.suggested.length === 0) {
          this.showEmpty = true
          this.$refs.cmap.hideMap()
        } else {
          this.showEmpty = false
          this.$refs.cmap.showMap('suggest', this.suggested)
        }
      } else {
        const currentArray = this.routes[this.tabs[index].type]
        this.currentArray = currentArray
        if (!currentArray || currentArray.length === 0 || this.siteId === '129' && index === 2) {
          this.showEmpty = true
          this.$refs.cmap.hideMap()
        } else {
          this.showEmpty = false
          this.$refs.cmap.showMap(this.tabs[index].type, currentArray)
        }
      }
    },
    // 在地图上显示路线
    handleShowMap (detail) {
      this.$refs.cmap.showMap(detail.type, this.currentArray, detail.index)
      // this.showMap = true
    },
    // 选择起点
    handleSelectStart () {
      this.$refs.navigateSearch.show('start')
    },
    // 选择终点
    handleSelectEnd () {
      this.$refs.navigateSearch.show('end')
    },
    handleExchange () {
      let oldStart = Object.assign({}, this.start)
      this.start = Object.assign({}, this.end)
      this.end = oldStart
      this.$nextTick(() => {
        console.log('交换了起止位置，请求数据')
        if (this.start.lon && this.end.lon) {
          this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
          })
          this.toast.show()
          this.getData(this.active)
        }
      })
    },
    // 根据搜索结果设置起止点
    handleSelectPlace (data) {
      console.log('搜索结果', data)
      if (data.type === 'start') {
        if (!data.detail.lon) {
          this.$createDialog({
            type: 'alert',
            confirmBtn: {
              text: this.$t('common.confirm')
            },
            content: this.$t('navigate.noteMsg')
          }).show()
          this.start = {
          }
        } else {
          this.start = {
            name: data.detail.name,
            lon: data.detail.lon,
            lat: data.detail.lat,
            type: data.detail.type,
            id: data.detail.id
          }
        }
      } else {
        this.end = {
          name: data.detail.name,
          lon: data.detail.lon,
          lat: data.detail.lat,
          type: data.detail.type,
          id: data.detail.id
        }
      }
      this.$nextTick(() => {
        if (this.start.lon && this.end.lon) {
          console.log('选择了搜索结果，请求数据')
          this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
          })
          this.toast.show()
          this.getData(this.active)
        }
      })
    },
    handleChangeRoute (index) {
      this.currentIndex = index
    },
    // 找到bus在transporation中的index
    findBus (route, realIndex) {
      let order = 0
      for (let i = 0; i < route.routeArray.length; i++) {
        const item = route.routeArray[i]
        if (item.type !== 0 && item.type !== 7) {
          if (i === realIndex) {
            return order
          }
          order += 1
        }
      }
      return ''
    },
    handleMask (value) {
      this.showMask = value
    },
    // 点击开始导航
    handleNavigate () {
      console.log('当前状态', this.inThere)
      if (!this.inThere) {
        let text = ''
        if (this.siteId === '245') {
          text = this.$t('navigate.notInRws')
        } else if (this.siteId === '129') {
          text = this.$t('navigate.notInSingapore')
        } else if (this.siteId === '33') {
          text = this.$t('navigate.notInGermany')
        } else {
          text = this.$t('navigate.notInSentosa')
        }
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: text
        })
        this.toast.show()
        return
      }
      if (this.geoData && this.geoData.lon) {
          this.inNavigation = true
          this.playAudio(this.$t('navigate.startTxt'))
          this.$refs.routeDetail.handleClose()
          this.$nextTick(() => {
            this.$refs.cmap.startNavigate(this.geoData)
          })
      } else {
        this.toast = this.$createToast({
          type: 'txt',
          txt: this.$t('navigate.errorMsg')
        })
        this.toast.show()
      }
    },
    handleStopMonitor () {
      if (this.Android) {
        window.removeEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
      } else {
        window.removeEventListener('deviceorientation', this.handleOrientation)
      }
      window.navigator.geolocation.clearWatch(this.watchId)
    },
    handleStop () {
      this.inNavigation = false
      this.$refs.audio.pause()
      this.isPlaying = false
      this.audioSrc = ''
    },
    closeRouteDetail () {
      this.$refs.routeDetail.handleClose()
    },
    playAudio (text) {
      console.log('是否在导航模式下', this.inNavigation)
      if (!this.inNavigation) return
      const audio = this.$refs.audio
      console.log('================是否正在播放,', this.isPlaying)
      // Play video function
      if (!this.isPlaying && !this.audioSrc) {
        this.audioSrc = "https://web.sdk.map.brtbeacon.com/api/voice/txt_to_voice?text=" + encodeURIComponent(text) + "&types=0";
        this.$nextTick(() => {
          audio.currentTime = 0
          audio.play()
        })
      } else {
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = setInterval(() => {
          if (!this.inNavigation) {
            clearInterval(this.timer)
            return
          }
          if (!this.isPlaying && !this.audioSrc) {
            clearInterval(this.timer)
            this.audioSrc = "https://web.sdk.map.brtbeacon.com/api/voice/txt_to_voice?text=" + encodeURIComponent(text) + "&types=0";
            this.$nextTick(() => {
              audio.currentTime = 0
              audio.play()
            })
          }
        }, 300)
      }
    },
    processText (text) {
      const string = text.toLowerCase()
      if (/continue/.test(string)) {
        return this.$t('navigate.continue')
      } else if (/turn right/.test(string)) {
        return this.$t('navigate.turnRight')
      } else if (/turn left/.test(string)) {
        return this.$t('navigate.turnLeft')
      } else if (/turn slight right/.test(string)) {
        return this.$t('navigate.turnSlightRight')
      } else if (/turn slight left/.test(string)) {
        return this.$t('navigate.turnSlightLeft')
      } else if (/turn sharp left/.test(string)) {
        return this.$t('navigate.turnSharpLeft')
      } else if (/turn sharp right/.test(string)) {
        return this.$t('navigate.turnSharpRight')
      } else if (/finish/.test(string)) {
        return 'finish'
      } else {
        return text
      }
    },
    handlePlayAudio (obj) {
      console.log('===================obj',obj)
      // text street_name distance
      let playText = ''
      const directionText = this.processText(obj.text)
      console.log('directionText', directionText)
      if (/finish/.test(directionText)) {
        if (obj.distance < 5) {
          playText = this.$t('navigate.arriveInfo')
          this.playAudio(playText)
          this.audioTimer = setInterval(() => {
            const audio = this.$refs.audio
            if (audio.paused) {
              clearInterval(this.audioTimer)
              this.$refs.cmap.handleBack()
            }
          }, 300)
        } else {
          playText = this.$t("navigate.distanceMsg", { distance: this.formatDistance(obj.distance) }) + ' ' + this.$t('navigate.finish')
          this.playAudio(playText)
        }
      } else {
        playText = obj.distance > 5 ? this.$t("navigate.distanceMsg", { distance: this.formatDistance(obj.distance) }) + ' ' : ''
        playText += directionText
        playText += obj.street_name ? ` ${this.$t('navigate.enter')} ${obj.street_name}` : ''
        this.playAudio(playText)
      }
    },
    formatDistance (val) {
      if (val < 1000) {
        return Math.round(val) + this.$t('common.metre')
      } else {
        const km = Math.round(parseInt(val * 10) / 1000) / 10
        return km + $t('common.kilometre')
      }
    },
    handleHistories (array) {
      this.results = array.map(item => {
        let distance = ''
        if (this.geoData && this.geoData.lon) {
          distance = GetDistance(this.geoData.lat, this.geoData.lon, item.lat, item.lon)
        }
        item.distance = distance
        return item
      })
    },
    // 请求导航历史
    getHistoryList () {
      let params = {
        locale: this.$i18n.locale
      }
      this.$route.query.language == 'zh' ? params.locale = 'cn' : params.locale = 'en'
      getNavHistories(this.header, params).then(res => {
        this.noResults = res.nav_histories.length == 0
        this.handleHistories(res.nav_histories.map(item => item.place))
        // this.toast.hide()
      })
    },
    // 删除导航历史
    handleDelete () {
      this.toast = this.$createToast({
        time: 0,
        txt: this.$t('common.loadingMsg'),
        mask: true
      })
      this.toast.show()
      deleteNavHistory(this.header).then(res => {
        this.noResults = true
        this.results = []
        this.toast.hide()
      })
    },
    handleClickResult (index) {
      const place = this.results[index]
      if(!this.start.name) {
        this.start = {
          name: place.name,
          lon: place.lon,
          lat: place.lat,
          id: place.id,
          type: place.type
        }
      } else {
        this.end = {
          name: place.name,
          lon: place.lon,
          lat: place.lat,
          id: place.id,
          type: place.type
        }
      }
      this.$nextTick(() => {
        if (this.start.lon && this.end.lon) {
          this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
          })
          this.toast.show()
          console.log('选择了搜索结果，请求数据')
          this.getData(this.active)
        }
      })
    },
    // 使用其他地图
    handleWechatNav () {
      window.wx.miniProgram.postMessage({
        data: {
          lon: this.end.lon,
          lat: this.end.lat,
          name: this.end.name
        }
      })
      window.wx.miniProgram.navigateBack()
    }
  }
}
</script>

<style lang="scss" scoped>
.navigate {
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  z-index: 10;
  background-color: #ffffff;
  height: 130px;
  transition: height 0.2s ease-in-out;
  overflow: hidden;

  &-wrapper {
    position: relative;
    height: 100vh;
    overflow: hidden;
  }
  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 0 0 12px;
  
  }
  .naviagte-top__left {
    margin-right: 11px;
    height: 26px;
    width: 26px;
    align-self: flex-start;
  }

  .current-location {
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    height: 32px;

    img {
      width: 24px;
      height: 24px;
      display: block;
      margin-right: 6px;
    }
  }

  .location {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    font-size: 14px;
    line-height: 24px;
    color: #222215;

    &.disable {
      color: #888888;
    }
  }

  .destination {
    margin-top: 8px;
    background-color: #f3f3f3;
    display: flex;
    align-items: center;
    height: 32px;
    img {
      width: 24px;
      height: 24px;
      display: block;
      margin-right: 6px;
    }

    .navigate-input {
      width: 100%;
      height: 32px;
      background-color: transparent;
      font-size: 14px;
      line-height: 32px;
      margin-left: 6px;
    }
  }

  &-form {
    flex: 1;
    width: calc(100% - 56px);
  }

  .exchange {
    width: 56px;
    height: 60px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-tabs {
    display: flex;
    font-size: 14px;
    color: #888888;
    padding: 12px;
    transition: all 0.3s ease-out;
    justify-content: space-between;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    &.en-tabs {
      justify-content: flex-start;
      padding: 12px 0;
    }

    .tab-wrapper {
      width: 60px;

      &.en-wrapper {
        width: auto;
        margin-right: 30px;

        &:first-child {
          margin-left: 12px;
        }

        &:last-child {
          margin-right: 12px;
        }
      }
    }

    .tab {
      width: 45px;
      white-space: nowrap;
      height: 22px;
      text-align: center;
      line-height: 22px;
      border-radius: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      // transition: width 0.3s ease-out;
      transition: all 0.2s ease-in-out;

      &.en-tab {
        padding: 0 6px;
        width: auto;

        &.active {
          width: auto;
        }
      }

      .icon {
        width: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
        opacity: 0;
      }

      &.active {
        color: #ffffff;
        font-weight: bold;
        font-family: GothamBold;
        background-color: #f8a909;
        width: 60px;

        .icon {
          opacity: 1;
        }
      }
    }
  }

  &-route {
    height: 100vh;
    background-color: #f7f7f7;
  }
}

.empty-wrapper {
  padding-top: 130px;
  height: 100%;

  .bus-empty {
    margin-top: 81px;

    img {
      display: block;
      width: 214px;
      margin: 0 auto;
    }
  }

  .empty-text {
    font-size: 16px;
    line-height: 22px;
    color: #888888;
    width: 229px;
    text-align: center;
    margin: 12px auto 22px;
  }

  .empty-bus-btn {
    width: 168px;
    height: 32px;
    font-size: 16px;
    color: #ffffff;
    border-radius: 16px;
    background-color: #f8a909;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
}

.result-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 -12px;
  padding: 16px 12px 0;
  border-top: 6px solid #f7f7f7;

  .title {
    font-size: 16px;
    color: #222215;
  }
}
.list-wrapper {
  max-height: calc(100vh - 210px);
  overflow: auto;
}

.no-results {
  text-align: center;
  font-size: 12px;
  color: #888888;
  margin-top: 30px;
}
.result-wrapper {
  padding: 130px 12px 40px;
  height: 100%;
  background-color: #ffffff;
  position: relative;
  z-index: 5;
}
.start-nav {
  line-height: 37px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  font-family: GothamBold;
  color: #f8a909;
  background-color: #ffffff;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding-top: 1px;

  &.shadow {
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    &.after {
      display: none;
    }
  }

  &:after {
    width: calc(100% - 24px);
    content: '';
    height: 1px;
    background-color: #efefef;
    position: absolute;
    left: 12px;
    top: 0;
  }
}

.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(34, 33, 37, 0.75);
  z-index: 10;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
